{
    "component-card-search-list.empty-state.title.non-final": "<strong>Dieses Repository mit einer Softwarekomponente verknüpfen</strong>",
    "component-card.add-chat-channel": "Chatkanal hinzufügen",
    "component-card.chat-channels": "Chatkanäle",
    "component-card.expander.show-more-link": "{formattedCount} weitere anzeigen"
}
